import { z } from "zod";

// 2d or 3d coordinates
const Coordinate = z.array(z.number()).min(2).max(3);

// 2d or 3d bbox
const BBox = z.tuple([z.number(), z.number(), z.number(), z.number()]).or(z.tuple([z.number(), z.number(), z.number(), z.number(), z.number(), z.number()]));


// geometries
export const PointGeometrySchema = z.object({
	type: z.literal("Point"),
	coordinates: Coordinate,
});

export const MultiPointGeometrySchema = z.object({
	type: z.literal("MultiPoint"),
	coordinates: z.array(Coordinate),
});

export const LineStringGeometrySchema = z.object({
	type: z.literal("LineString"),
	coordinates: z.array(Coordinate),
});

export const MultiLineStringGeometrySchema = z.object({
	type: z.literal("MultiLineString"),
	coordinates: z.array(z.array(Coordinate)),
});

export const PolygonGeometrySchema = z.object({
	type: z.literal("Polygon"),
	coordinates: z.array(z.array(Coordinate)),
});

export const MultiPolygonGeometrySchema = z.object({
	type: z.literal("MultiPolygon"),
	coordinates: z.array(z.array(z.array(Coordinate))),
});

export const GeometrySchema = z.union([
	PointGeometrySchema,
	MultiPointGeometrySchema,
	LineStringGeometrySchema,
	MultiLineStringGeometrySchema,
	PolygonGeometrySchema,
	MultiPolygonGeometrySchema
])

export const FeatureSchema = z.object({
	bbox: BBox.optional(),
	type: z.literal("Feature"),
	id: z.union([z.string(), z.number()]).optional(),
	geometry: GeometrySchema,
	properties: z.record(z.string(), z.any()).default({}),
});
export type TFeature = z.infer<typeof FeatureSchema>

export const PointSchema = FeatureSchema.merge(z.object({ geometry: PointGeometrySchema }))
export type TPoint = z.infer<typeof PointSchema>

export const MultiPointSchema = FeatureSchema.merge(z.object({ geometry: MultiPointGeometrySchema }))
export type TMultiPoint = z.infer<typeof MultiPointSchema>

export const LineStringSchema = FeatureSchema.merge(z.object({ geometry: LineStringGeometrySchema }))
export type TLineString = z.infer<typeof LineStringSchema>

export const MultiLineStringSchema = FeatureSchema.merge(z.object({ geometry: MultiLineStringGeometrySchema }))
export type TMultiLineString = z.infer<typeof MultiLineStringSchema>

export const PolygonSchema = FeatureSchema.merge(z.object({ geometry: PolygonGeometrySchema }))
export type TPolygon = z.infer<typeof PolygonSchema>

export const MultiPolygonSchema = FeatureSchema.merge(z.object({ geometry: MultiPolygonGeometrySchema }))
export type TMultiPolygon = z.infer<typeof MultiPolygonSchema>


export interface TFeatureCollection<T extends TFeature = TFeature> {
	type: "FeatureCollection";
	features: Array<T>;
}
